import React from "react";
import "./styles/NewJobUI.css";
import {
  FiArrowLeft,
  FiBriefcase,
  FiMapPin,
  FiClock,
  FiCheckCircle,
  FiBookmark,
  FiCalendar,
} from "react-icons/fi";

const JobDetailsPage = ({ job, onBack, onApply, onSave }) => {
  const skills = job?.requirements?.skills?.mandatory || [];
  const certs = job?.requirements?.certifications?.mandatory || [];

  const hasEducation = Boolean(job?.requirements?.education?.minimum);
  const minEdu = job?.requirements?.education?.minimum;

  const minYears = job?.requirements?.experience?.minimumYears ?? 0;
  const hasMinYears = minYears > 0;

  const postedDate = job?.publishedAt ? new Date(job.publishedAt).toLocaleDateString() : "—";
  const closingDate = job?.expiryDate ? new Date(job.expiryDate).toLocaleDateString() : "—";

  if (!job) return null;

  return (
    <div className="jb-card">
      <button className="jb-back" onClick={onBack}>
        <FiArrowLeft className="jb-back-ic" />
        Back to Job Board
      </button>

      <div className="jb-details-head">
        <div className="jb-details-left">
          <div className="jb-title-row">
            <h2 className="jb-title">{job.title}</h2>
            <span className="jb-badge jb-badge--active">Active</span>
          </div>

          <div className="jb-submeta">
            <span className="jb-meta-item">
              <FiBriefcase className="jb-meta-icon" />
              {job.department || "—"}
            </span>

            <span className="jb-meta-item">
              <FiMapPin className="jb-meta-icon" />
              {job.location || "—"}
            </span>

            <span className="jb-meta-item">
              <FiClock className="jb-meta-icon" />
              {job.type || "—"}
            </span>
          </div>
        </div>

        <button className="jb-icon-btn" title="Save" onClick={onSave}>
          <FiBookmark />
        </button>
      </div>

      <div className="jb-section">
        <h3>Job Description</h3>
        <p className="jb-text">{job.description || "—"}</p>
      </div>

      <div className="jb-divider" />

      <div className="jb-section">
        <h3>Required Qualifications</h3>

        {skills.length === 0 ? (
          <p className="jb-text">—</p>
        ) : (
          <ul className="jb-list jb-list--ticks">
            {skills.map((s, i) => (
              <li key={i}>
                <FiCheckCircle className="jb-tick" />
                {s}
              </li>
            ))}
          </ul>
        )}
      </div>

      <div className="jb-divider" />

      <div className="jb-section">
        <h3>Eligibility Criteria</h3>

        <ul className="jb-list jb-list--ticks">
          {certs.map((c, i) => (
            <li key={`cert-${i}`}>
              <FiCheckCircle className="jb-tick" />
              {c}
            </li>
          ))}

          {hasEducation && (
            <li>
              <FiCheckCircle className="jb-tick" />
              Minimum education: {minEdu}
            </li>
          )}

          {hasMinYears && (
            <li>
              <FiCheckCircle className="jb-tick" />
              Minimum experience: {minYears} years
            </li>
          )}

          {certs.length === 0 && !hasEducation && !hasMinYears && (
            <li>
              <FiCheckCircle className="jb-tick" />—
            </li>
          )}
        </ul>
      </div>

      <div className="jb-footer">
        <div className="jb-dates">
          <div className="jb-date-row">
            <FiCalendar className="jb-meta-icon" />
            Posted: {postedDate}
          </div>
          <div className="jb-date-row">
            <FiCalendar className="jb-meta-icon" />
            Closing: {closingDate}
          </div>
        </div>

        <div className="jb-actions">
          <button className="jb-btn jb-btn--ghost" onClick={onSave}>
            Save
          </button>
          <button className="jb-btn jb-btn--primary" onClick={onApply}>
            Apply for this Position
          </button>
        </div>
      </div>
    </div>
  );
};

export default JobDetailsPage;
